import React, { useEffect, forwardRef } from 'react'
import { useKeyPress } from 'hooks'
import ZoomableImage from 'components/ZoomableImage'
import ImageViewerFooter from 'components/ImageViewer/ImageViewerFooter'

const ImageViewer = (
    { image, onPrevFile, onNextFile, onToggleFullscreen, defaultFullscreen, totalFiles, fileIndex },
    ref
) => {
    const rightArrowkeyPressed = useKeyPress('ArrowRight')
    const leftArrowkeyPressed = useKeyPress('ArrowLeft')

    useEffect(() => {
        if (rightArrowkeyPressed) {
            onNextFile()
        }
    }, [rightArrowkeyPressed])

    useEffect(() => {
        if (leftArrowkeyPressed) {
            onPrevFile()
        }
    }, [leftArrowkeyPressed])

    return (
        <div className="image-viewer-container fullscreen-wrapper">
            <div
                className="image-container"
                onDoubleClick={() => {
                    onToggleFullscreen()
                }}
            >
                <ZoomableImage image={image} />
            </div>

            <div className="image-viewer-footer" ref={ref}>
                <ImageViewerFooter
                    onToggleFullscreen={onToggleFullscreen}
                    isFullscreen={defaultFullscreen}
                    fileIndex={fileIndex}
                    totalFiles={totalFiles}
                />
            </div>
        </div>
    )
}

export default forwardRef(ImageViewer)
